/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type UniversalSnippetHitSchemaVisibility = typeof UniversalSnippetHitSchemaVisibility[keyof typeof UniversalSnippetHitSchemaVisibility];


export const UniversalSnippetHitSchemaVisibility = {
  private: 'private',
  shared: 'shared',
} as const;
